import React, { useRef, useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import { useParams } from "react-router-dom";
// import env from "react-dotenv";

export default function EditMillConsumption() {
  //state definintion
  const [form, setForm] = useState({
    year: "",
    carryIn: "",
    production: "",
    import: "",
    millConsumption: "",
    export: "",
    carryOut: "",
  });

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);

  //year handler
  const yearHandler = (e) => {
    setForm({ ...form, year: e.target.value });
  };

  //caaryIn handler
  const carryInHandler = (e) => {
    setForm({ ...form, carryIn: e.target.value });
  };

  //production handler
  const productionHandler = (e) => {
    setForm({ ...form, production: e.target.value });
  };

  //import handler
  const importHandler = (e) => {
    setForm({ ...form, import: e.target.value });
  };

  //millConsumption
  const millConsumptionHandler = (e) => {
    setForm({ ...form, millConsumption: e.target.value });
  };

  //export handler
  const exportHandler = (e) => {
    setForm({ ...form, export: e.target.value });
  };

  //carryOut handler
  const carryOutHandler = (e) => {
    setForm({ ...form, carryOut: e.target.value });
  };

  const { _id } = useParams();
  const gerrit = async () => {
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/getMCs/${_id}`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    const data = await response.json();
    setForm({
      ...form,
      year: data.year,
      carryIn: data.carryIn,
      production: data.production,
      import: data.import,
      millConsumption: data.millConsumption,
      export: data.export,
      carryOut: data.carryOut,
    });
  };

  useEffect(() => {
    gerrit();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/updateMC/${_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(form),
      }
    );
    // .then(console.log(form))
    // .then(console.log("Successfully submitted!"))}

    return (
      <>
        <div className="sidebar">
          <Sidebar />
        </div>
        <div id="bydrop">
          <form onSubmit={handleSubmit}>
            <label for="formGroupExampleInput" class="form-label">
              Year
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.year}
                required
                type="number"
                ref={ref1}
                onChange={yearHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <label for="formGroupExampleInput" class="form-label">
              Carry In
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.carryIn}
                required
                type="number"
                ref={ref2}
                onChange={carryInHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <label for="formGroupExampleInput" class="form-label">
              Production
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.production}
                required
                type="number"
                ref={ref3}
                onChange={productionHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <label for="formGroupExampleInput" class="form-label">
              Import
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.import}
                required
                type="number"
                ref={ref4}
                onChange={importHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <label for="formGroupExampleInput" class="form-label">
              Mill Consumption
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.millConsumption}
                required
                type="number"
                ref={ref5}
                onChange={millConsumptionHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <label for="formGroupExampleInput" class="form-label">
              Export
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.export}
                required
                type="number"
                ref={ref6}
                onChange={exportHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <label for="formGroupExampleInput" class="form-label">
              Carry Out
            </label>
            <div class="input-group input-group-sm mb-3">
              <input
                value={form.carryOut}
                required
                type="number"
                ref={ref7}
                onChange={carryOutHandler}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <button type="submit" className="btn btn-secondary btn-lg">
              Submit
            </button>
          </form>
        </div>
      </>
    );
  };
}
